"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.masker = void 0;
const dynamic_mask_1 = require("./dynamic-mask");
const mask_it_1 = require("./mask-it");
const masker = (value, mask, tokens, masked = true) => {
    return Array.isArray(mask)
        ? (0, dynamic_mask_1.dynamicMask)(mask_it_1.maskIt, mask, tokens)(value, masked)
        : (0, mask_it_1.maskIt)(value, mask, tokens, masked);
};
exports.masker = masker;
